import { MILLISECONDS_IN_MINUTE } from '@stdlib/constants-time';
import { useQuery } from '@tanstack/react-query';
import { useMemo } from 'react';

import type { ExperienceStatus } from 'app/typings/core/admin/experiences/enum/experienceStatus';
import type { SearchExperienceResponse } from 'app/typings/core/admin/experiences/experienceList';
import { apiRequest } from 'app/utils/request/api';

import { CORE_QUERY_KEYS, ENDPOINTS } from '.';

type ExperiencesListQueryParam = {
  search?: string;
  sorting?: string;
  status?: ExperienceStatus[];
  pageNumber?: number;
};

export function useExperiences(queryParams: ExperiencesListQueryParam = {}) {
  const formattedQueryParams = useMemo(() => {
    return {
      ...queryParams,
    };
  }, [queryParams]);

  const key = useMemo(() => {
    return [CORE_QUERY_KEYS.experiences, { ...formattedQueryParams }];
  }, [formattedQueryParams]);

  return useQuery({
    queryKey: key,
    queryFn: () =>
      apiRequest({
        path: ENDPOINTS.getExperiences,
        queryParams: formattedQueryParams,
      }) as Promise<SearchExperienceResponse>,
    staleTime: 5 * MILLISECONDS_IN_MINUTE,
  });
}
